/**
 * Vehicle photo + colour-swatch helpers.
 *
 * Extracted verbatim from the copies that lived in ContractsRecords.tsx and
 * ContractDepositsRecords.tsx so the thumbnail treatment has one source.
 */

/**
 * Derive the SBT Japan hero photo for a vehicle from its listing URL.
 * Returns null when the URL is missing or is not an SBT listing.
 * `updatedAt` cache-busts so a re-scraped listing shows its new photo.
 */
export function getSbtPhotoUrl(
    listingUrl: string | null | undefined,
    updatedAt: string | null | undefined,
): string | null {
    if (!listingUrl) return null;
    const match = listingUrl.match(/sbtjapan\.com\/used-cars\/([A-Z0-9]+)/i);
    if (!match) return null;
    const cacheBust = updatedAt ? `?v=${new Date(updatedAt).getTime()}` : '';
    return `https://img.sbtjapan.com/img/carphoto/${match[1]}/normal/f.jpg${cacheBust}`;
}

/** Normalise a stored colour ('1A2B3C', '#1A2B3C', 'silver') into a CSS colour. */
export function getColorValue(color: string): string {
    const trimmed = color.trim();
    if (/^[0-9A-Fa-f]{6}$/.test(trimmed)) return `#${trimmed}`;
    if (trimmed.startsWith('#')) return trimmed;
    return trimmed;
}
